module.exports = {
  title: '套餐权益',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-package-benefits',
    },
  },
};
